import React, { useEffect, useState } from "react";
import ChatSidebar from "./chat-sidebar/ChatSidebar";
import MessageContainer from "./messages/MessageContainer";
import { useSelector } from "react-redux";

const ChatComponent = () => {
  const [onlineUsers, setOnlineUsers] = useState({});
  const connection = useSelector((state) => state.socket.socketConnection);

  // Fetch and update online users status
  useEffect(() => {
    if (connection) {
      connection.on("UserStatusChanged", (userId, status) => {
        setOnlineUsers((prevUsers) => ({
          ...prevUsers,
          [userId]: status,
        }));
      });

      connection
        .invoke("GetOnlineUsers")
        .then((users) => {
          const updatedOnlineUsers = users.reduce((acc, user) => {
            acc[user] = "true";
            return acc;
          }, {});
          setOnlineUsers(updatedOnlineUsers);
        })
        .catch((err) => {
          console.error("Error fetching online users:", err);
        });

      return () => {
        connection.off("UserStatusChanged");
      };
    }
  }, [connection]);

  return (
    <div
      className="flex flex-1 min-h-0 min-w-0 overflow-hidden bg-blue-200 bg-opacity-15 backdrop-blur-lg"
      style={{ fontFamily: "'Mulish', 'Noto Color Emoji', sans-serif" }}
    >
      <ChatSidebar onlineUsers={onlineUsers} />
      <MessageContainer onlineUsers={onlineUsers} />
    </div>
  );
};

export default ChatComponent;
